import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { LoadingComponent } from './loading/loading.component';
import { AuthService } from '../../core/auth/auth.service';



@Component({
  selector: 'app-auth-check',
  standalone: true,
  imports: [CommonModule, LoadingComponent],
  templateUrl: 'auth-check.component.html',
  styleUrls: ['auth-check.component.scss']
})
export class AuthCheckComponent implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);

  ngOnInit(): void {
    // Check auth state and redirect accordingly after a short delay to show loading
    setTimeout(() => this.checkAuthAndRedirect(), 1500);
  }

  private checkAuthAndRedirect(): void {
    // Skip if still loading
    if (this.authService.isLoading()) {
      // Check again in 500ms
      setTimeout(() => this.checkAuthAndRedirect(), 500);
      return;
    }

    if (this.authService.isAuthenticated()) {
      // User is authenticated, continue to requested route
      const savedUrl = sessionStorage.getItem('auth_return_url') || '/home';
      sessionStorage.removeItem('auth_return_url');
      this.router.navigateByUrl(savedUrl);
    } else {
      // User is not authenticated, redirect to login
      this.router.navigate(['/auth/login']);
    }
  }
}
